// extracted by mini-css-extract-plugin
export var countryCode = "SingleScreenPopupWithMobile-module--countryCode--74777";
export var coupon = "SingleScreenPopupWithMobile-module--coupon--1ee7a";
export var cross = "SingleScreenPopupWithMobile-module--cross--b3595";
export var customFont = "SingleScreenPopupWithMobile-module--customFont--8db31";
export var cyberSalePhoneInput = "SingleScreenPopupWithMobile-module--cyberSalePhoneInput--0ceab";
export var diwaliSalePhoneInput = "SingleScreenPopupWithMobile-module--diwaliSalePhoneInput--b8573";
export var email = "SingleScreenPopupWithMobile-module--email--c073a";
export var modal = "SingleScreenPopupWithMobile-module--modal--be22c";